import { statusToStr } from '@/_schemas/status-input';
import { dateTime } from '@/_shared';

import { authenticationTypeToStr } from '../components/authentication-type';
import { type ConnectedAppFormSchema, type ConnectedAppMutationSchema } from '../schemas';
import type { APIKeyFormSchema, APIKeyMutationSchema } from '../schemas/api-keys-schemas';
import { environmentToStr } from '../schemas/api-keys-schemas/environment-schema';

export function connectedAppFormToUpdate({
  brand,
  legal_entity,
  ...rest
}: ConnectedAppFormSchema): ConnectedAppMutationSchema {
  return {
    ...rest,
    brand_id: brand?.id ?? null,
    legal_entity_id: legal_entity?.id ?? null,
    authentication_type: authenticationTypeToStr(rest.authentication_type),
  };
}

export function apiKeyFormToUpdate(apiKeys: APIKeyFormSchema[], api_integration_id: number): APIKeyMutationSchema[] {
  return apiKeys.map((apiKey) => ({
    ...apiKey,
    environment: environmentToStr(apiKey.environment),
    status: statusToStr(apiKey.status),
    api_integration_id,
    expiration_date: apiKey.expiration_date ? dateTime.format(apiKey.expiration_date, 'YYYY-MM-DD') : null,
  }));
}
